import { render } from "./Confirmation.vue?vue&type=template&id=641c55e5&scoped=true"
import script from "./Confirmation.vue?vue&type=script&lang=js"
export * from "./Confirmation.vue?vue&type=script&lang=js"

import "./Confirmation.vue?vue&type=style&index=0&id=641c55e5&lang=scss&scoped=true"

import exportComponent from "/Users/richardpitul/Projects/booking-calendars/athletics-booking-calendar/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641c55e5"]])

export default __exports__